import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Ruler, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function UnitaMisura() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/units").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/units", { name: name.trim() }); setName(""); toast.success("Unità aggiunta"); load(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const remove = async (id) => { try { await api.delete(`/units/${id}`); toast.success("Eliminata"); load(); } catch (e) { toast.error("Errore"); } };

  return (
    <div className="mx-auto max-w-2xl">
      <div className="mb-6">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900">Unità di misura</h1>
        <p className="mt-1 text-sm text-slate-500">Definisci le unità (es. m, mq, pz, kg, h) usate nelle voci dei listini.</p>
      </div>
      <Card className="rounded-lg border-slate-200 p-5 shadow-sm">
        <div className="mb-4 flex gap-2">
          <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Nuova unità (es. mq)" data-testid="unit-name-input" className="flex-1" />
          <Button onClick={add} data-testid="add-unit-btn" className="rounded-md bg-[#002FA7] text-white hover:bg-[#00227A]"><Plus className="mr-1 h-4 w-4" /> Aggiungi</Button>
        </div>
        {items.length === 0 ? (
          <div className="flex flex-col items-center gap-2 py-12 text-center text-slate-400"><Ruler className="h-8 w-8 text-slate-300" /><p>Nessuna unità definita</p></div>
        ) : (
          <div className="flex flex-wrap gap-2" data-testid="units-list">
            {items.map((u) => (
              <div key={u.id} data-testid={`unit-${u.id}`} className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm">
                <span className="font-medium text-slate-800">{u.name}</span>
                <button onClick={() => remove(u.id)} data-testid={`delete-unit-${u.id}`} className="text-slate-400 hover:text-rose-600"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
